export function getParameterByName(name, url) {
    if (!url) url = window.location.href;

    name = name.replace(/[[]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./src/helpers/location.js